import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const LogoImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 10px;
`

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  color: ${theme.colors.black};
  position: absolute;
  top: 30%;
  left: 0;
  font-size: 18px;
  svg {
    path {
      fill: ${theme.colors.white};
    }
  }
`

export const WrapperHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
`

export const TermsContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 40vh;
  width: 60%;
  overflow-y: auto;
  padding: 20px;

  h2 {
    text-align: center;
    margin-bottom: 25px;
    color: ${theme.colors.gray700};
  }

  p {
    color: ${theme.colors.gray500};
  }

  h3 {
    color: ${theme.colors.gray600};
  }

  ul {
    margin-left: 20px;
  }
`
